import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';

export class SourceModel {
  public channelType?: string;

  constructor(params: SourceModel) {
    this.channelType = params.channelType;
  }

  public static fromCheckoutV1(channelType?: string | null) {
    return new SourceModel({
      channelType: mapNullToUndefined(channelType),
    });
  }
}
